import Component from '../core/Component'
import EventBus from '../core/EventBus'
import support from '../utils/BrowserSupport'
import { disableScrolling, enableScrolling } from '../services/Viewport/scroll'
import keycode from 'keycode'

export const STATES = {
    VISIBLE: 'is-visible',
    ACTIVE: 'is-active'
}

export default class Search extends Component {
    constructor(element) {
        super(element);

        this.ref = {
            layer: null,
            background: null,
            closeButton: null
        }
    }

    prepare() {
        this.ref.layer.addEventListener(support.transitionEnd, () => {
            if (!this.element.classList.contains(STATES.ACTIVE)) {
                this.element.classList.remove(STATES.VISIBLE);
            }
        })
        this.ref.closeButton.addEventListener('click', ::this.handleCloseClick)
        this.ref.background.addEventListener('click', ::this.handleCloseClick)
    }

    destroy() {
        document.removeEventListener('keydown', this.handleKeyDown)
    }

    handleKeyDown = event => {
        if (keycode(event.keyCode) === 'esc') {
            this.close()
        }
    }

    handleCloseClick(event) {
        event.preventDefault()
        this.close()
    }

    open() {
        disableScrolling()
        this.element.classList.add(STATES.VISIBLE)
        this.element.offsetWidth
        this.element.classList.add(STATES.ACTIVE)

        const searchForm = Component.getFromElement(this.element.querySelector('[data-component="SearchForm"]'))

        if (searchForm) {
            searchForm.focus()
        }

        document.addEventListener('keydown', this.handleKeyDown)
    }

    close() {
        enableScrolling()
        this.element.classList.remove(STATES.ACTIVE)
        document.removeEventListener('keydown', this.handleKeyDown)
    }

    toggle() {
        if (this.is(STATES.ACTIVE)) {
            this.close()
        } else {
            this.open()
        }
    }
}